export const GET_CM_CREDIT_CARD_BANNER_DATA = 'GET_CM_CREDIT_CARD_BANNER_DATA';
export const SET_CM_CREDIT_CARD_BANNER_DATA = 'SET_CM_CREDIT_CARD_BANNER_DATA';
export const GET_CM_CREDIT_CARD_BANNER_DATA_ERROR = 'GET_CM_CREDIT_CARD_BANNER_DATA_ERROR';
